import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	container: {
		color: "#FFFFFF",
		maxWidth: "none",
		height: "100%",
		padding: 0,
		position: "relative",
		overflow: "hidden",
		[theme.breakpoints.up("lg")]: {
			display: "flex",
			flexWrap: "wrap",
			justifyContent: "space-between",
			"& .mco-extension-component-contact__item + .mco-extension-component-contact__item": {
				marginTop: 0,
				paddingTop: 0
			},
			"& .mco-extension-component-teasergroup2columns__item + .mco-extension-component-teasergroup2columns__item .mco-extension-component-teasergroup2columns__link": {
				textAlign: "right"
			},
			"& .mco-extension-component-teasergroup2columns__item:first-of-type .mco-extension-component-teasergroup2columns__link": {
				marginLeft: "auto"
			}
		}
	},
	headline: {
		fontSize: 35,
		fontWeight: 400,
		textAlign: "center",
		margin: "20px 0 -5px",
		width: "100%",
		[theme.breakpoints.up("lg")]: {
			fontSize: 55
		}
	}
}));

export default styles;
